import { Route } from '@angular/router';

export const appRoutes: Route[] = [
  {
    path: ':eventId',
    loadComponent: () => import('./pages/home/home.component').then(m => m.HomeComponent),
  },
  {
    path: '',
    pathMatch: 'full',
    loadComponent: () => import('./pages/home/home.component').then(m => m.HomeComponent),
  },
];
